import React, { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";
import { nav } from "../mock";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", onScroll);
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (target) => {
    const el = document.getElementById(target);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  const go = (target) => {
    setOpen(false);
    if (target === "contact") {
      navigate("/contact");
      return;
    }
    if (target === "hero") {
      if (location.pathname !== "/") navigate("/");
      else window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => scrollTo(target), 150);
    } else {
      scrollTo(target);
    }
  };

  // On dark pages (e.g. /contact) the top-of-page navbar sits on a dark bg already.
  return (
    <>
      <header
        className={`fixed left-0 top-0 z-50 w-full transition-all duration-500 ${
          scrolled
            ? "border-b border-white/10 bg-[#16100C]/55 py-4 backdrop-blur-md"
            : "bg-transparent py-6"
        }`}
      >
        <div className="mx-auto flex max-w-[1400px] items-center justify-between px-6 md:px-10">
          <button onClick={() => go("hero")} className="flex items-center">
            <img
              src="/images/exp-luxury-white.webp"
              alt="eXp Luxury"
              className="h-7 w-auto object-contain md:h-8"
            />
          </button>

          <nav className="hidden items-center gap-10 md:flex">
            {nav.links.map((l) => (
              <button
                key={l.label}
                onClick={() => go(l.target)}
                className="whitespace-nowrap font-sans text-[11px] uppercase tracking-[0.3em] text-white/85 transition-colors hover:text-white"
              >
                {l.label}
              </button>
            ))}
          </nav>

          <button
            className="relative z-50 text-white md:hidden"
            onClick={() => setOpen(!open)}
            aria-label="Menu"
          >
            {open ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </header>

      <div
        className={`fixed inset-0 z-40 bg-[#16100C]/95 backdrop-blur-lg transition-all duration-500 md:hidden ${
          open ? "pointer-events-auto opacity-100" : "pointer-events-none opacity-0"
        }`}
      >
        <nav className="flex h-full flex-col items-center justify-center gap-8">
          {nav.links.map((l, i) => (
            <button
              key={l.label}
              onClick={() => go(l.target)}
              className={`font-sans text-sm uppercase tracking-[0.3em] text-[#F1E6D7]/85 transition-all duration-500 ${
                open ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"
              }`}
              style={{ transitionDelay: open ? `${150 + i * 80}ms` : "0ms" }}
            >
              {l.label}
            </button>
          ))}
        </nav>
      </div>
    </>
  );
}
